import { render } from "./OapPromoCard.vue?vue&type=template&id=b4f6c9c8"
import script from "./OapPromoCard.vue?vue&type=script&lang=js"
export * from "./OapPromoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__